import { USER_ROLES } from 'services/userService/constants';

interface Route {
    name: string;
    path: string;
    base: string;
    authenticated: boolean;
    allowedRoles: string[];
}

export const Routes: Route[] = [
    { name: 'Home', path: '/', base: '/', authenticated: false, allowedRoles: [] },
    {
        name: 'Engagements',
        path: '/engagements',
        base: '/engagements',
        authenticated: false,
        allowedRoles: [],
    },
    {
        name: 'Surveys',
        path: '/surveys',
        base: '/surveys',
        authenticated: false,
        allowedRoles: [],
    },
    {
        name: 'Feedback Tool',
        path: '/feedback',
        base: 'feedback',
        authenticated: true,
        allowedRoles: [USER_ROLES.VIEW_FEEDBACKS],
    },
    {
        name: 'Images',
        path: '/images',
        base: 'images',
        authenticated: true,
        allowedRoles: [USER_ROLES.CREATE_IMAGES],
    },
];
